import React, { useState } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { AiOutlineSave } from 'react-icons/ai'
import { FaRegEdit } from 'react-icons/fa'

import { ProfileImageModal } from '../../modal/profile-image-modal'
import { CustomDatePicker } from '../../datepicker'
import { Input, SearchSelect } from '../../input'
import { Button } from '../../buttons'

import { FONTS } from '../../../constants'
import {
  _title,
  _title_th,
  _marital_status,
  _gender,
  _status,
} from '../types'

import noImage from '../../../static/images/Not_available.jpg'

export const PersonalInfo = React.memo(props => {
  const {
    emp,
    invalid,
    employeeList = [],
    editPersonal,
    handleClickEdit,
    handleClickCancel,
    handleClickSavePersonal,
    handleInput,
  } = props
  const [showProfile, setShowProfile] = useState(false)

  const title = _title.find(t => t.value === emp.title) || null
  const title_th = _title_th.find(t => t.value === emp.title_th) || null
  const gender = _gender.find(g => g.value === emp.gender) || null
  const marital_status = _marital_status.find(m => m.value === emp.marital_status) || null
  const status = _status.find(s => s.value === emp.is_active) || null
  const updated_by = employeeList.find(e => e.value === emp.updated_by)

  return (
    <Root>
      <Container>
        <FormGroup>
          <ProfileWrapper>
            { showProfile &&
              <ProfileImageModal
                isOpen={ showProfile }
                handleClose={ () => setShowProfile(false) }
                src={ emp.image_thumbnail_url || noImage }
              />
            }
            <UserProfileImage
              src={ emp.image_thumbnail_url || noImage }
              onClick={ () => setShowProfile(!showProfile) }
            />
            <ProfileText>
              <span>Picture</span>
              <UploadArea>
                <InputFile
                  type='file'
                  id='profile_image'
                  name='file'
                  onChange={ e => handleInput(e, 'profile_image') }
                />
                <UploadText>Upload new picture</UploadText>
              </UploadArea>
            </ProfileText>
          </ProfileWrapper>
        </FormGroup>
        <Form>
          <FormWrapper>
            <FormGroup>
              <LabelCol>
                <Label required>Employee ID</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='emp_code'
                  placeholder='Enter Employee ID'
                  disabled={ !editPersonal }
                  value={ emp.emp_code || '' }
                  invalid={ invalid['emp_code'] }
                  onChange={ e => {
                    const value = e.target.value
                    if (!new RegExp('^[0-9]*$').test(value)) {
                      e.target.value = value.substring(0, value.length - 1)
                    }
                    handleInput(e.target.value, 'emp_code')
                  } }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>ID Card</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='id_card'
                  placeholder='Enter ID Card'
                  disabled={ !editPersonal }
                  value={ emp.id_card || '' }
                  invalid={ invalid['id_card'] }
                  onChange={ e => {
                    const value = e.target.value
                    if (!new RegExp('^[0-9]*$').test(value)) {
                      e.target.value = value.substring(0, value.length - 1)
                    }
                    handleInput(e.target.value, 'id_card')
                  } }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Title (EN)</Label>
              </LabelCol>
              <InputCol>
                <SearchSelect
                  name='title'
                  placeholder='Enter Title (EN)'
                  value={ title }
                  isDisabled={ !editPersonal }
                  options={ _title }
                  onChange={ e => handleInput(e, 'title') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Title (TH)</Label>
              </LabelCol>
              <InputCol>
                <SearchSelect
                  name='title_th'
                  placeholder='Enter Title (TH)'
                  value={ title_th }
                  isDisabled={ !editPersonal }
                  options={ _title_th }
                  onChange={ e => handleInput(e, 'title_th') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>First Name (EN)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='first_name'
                  placeholder='Enter First Name (EN)'
                  invalid={ invalid['first_name'] }
                  disabled={ !editPersonal }
                  value={ emp.first_name || '' }
                  onChange={ e => handleInput(e.target.value, 'first_name') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>Last Name (EN)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='last_name'
                  placeholder='Enter Last Name (EN)'
                  invalid={ invalid['last_name'] }
                  disabled={ !editPersonal }
                  value={ emp.last_name || '' }
                  onChange={ e => handleInput(e.target.value, 'last_name') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>First Name (TH)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='first_name_th'
                  placeholder='Enter First Name (TH)'
                  invalid={ invalid['first_name_th'] }
                  disabled={ !editPersonal }
                  value={ emp.first_name_th || '' }
                  onChange={ e => handleInput(e.target.value, 'first_name_th') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>Last Name (TH)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='last_name_th'
                  placeholder='Enter Last Name (TH)'
                  invalid={ invalid['last_name_th'] }
                  disabled={ !editPersonal }
                  value={ emp.last_name_th || '' }
                  onChange={ e => handleInput(e.target.value, 'last_name_th') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>Nickname (EN)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='nick_name'
                  placeholder='Enter Nickname (EN)'
                  invalid={ invalid['nick_name'] }
                  disabled={ !editPersonal }
                  value={ emp.nick_name || '' }
                  onChange={ e => handleInput(e.target.value, 'nick_name') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>Nickname (TH)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='nick_name_th'
                  placeholder='Enter Nickname (TH)'
                  invalid={ invalid['nick_name_th'] }
                  disabled={ !editPersonal }
                  value={ emp.nick_name_th || '' }
                  onChange={ e => handleInput(e.target.value, 'nick_name_th') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Birth Date</Label>
              </LabelCol>
              <InputCol>
                <CustomDatePicker
                  showYearDropdown
                  showMonthDropdown
                  autoComplete='off'
                  name='birth_date'
                  dateFormat='DD/MM/YYYY'
                  disabled={ !editPersonal }
                  selected={ emp.birth_date ? moment(emp.birth_date) : null }
                  onChange={ e => handleInput(e, 'birth_date') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>Gender</Label>
              </LabelCol>
              <InputCol>
                <SearchSelect
                  name='gender'
                  placeholder='Select Gender'
                  value={ gender }
                  invalid={ invalid['gender'] }
                  isDisabled={ !editPersonal }
                  options={ _gender }
                  onChange={ e => handleInput(e, 'gender') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Nationality</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='nationality'
                  placeholder='Enter Nationality'
                  disabled={ !editPersonal }
                  value={ emp.nationality || '' }
                  onChange={ e => handleInput(e.target.value, 'nationality') }
                />
              </InputCol>
            </FormGroup>
          </FormWrapper>
          <FormWrapper>
            <FormGroup>
              <LabelCol>
                <Label>Phone Number</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='phone'
                  placeholder='Enter Phone Number'
                  disabled={ !editPersonal }
                  value={ emp.phone || '' }
                  onChange={ e => {
                    const value = e.target.value
                    if (!new RegExp('^[0-9]*$').test(value)) {
                      e.target.value = value.substring(0, value.length - 1)
                    }
                    handleInput(e.target.value, 'phone')
                  } }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Personal Email</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='personal_email'
                  placeholder='Enter Personal Email'
                  disabled={ !editPersonal }
                  value={ emp.personal_email || '' }
                  onChange={ e => handleInput(e.target.value, 'personal_email') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Address</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='address'
                  placeholder='Enter Address'
                  disabled={ !editPersonal }
                  value={ emp.address || '' }
                  onChange={ e => handleInput(e.target.value, 'address') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Marital Status</Label>
              </LabelCol>
              <InputCol>
                <SearchSelect
                  name='marital_status'
                  placeholder='Select Marital Status'
                  value={ marital_status }
                  isDisabled={ !editPersonal }
                  options={ _marital_status }
                  onChange={ e => handleInput(e, 'marital_status') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Children</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='number_of_children'
                  placeholder='Enter Children'
                  type='number'
                  disabled={ !editPersonal }
                  value={ emp.number_of_children || '' }
                  onChange={ e => {
                    const value = e.target.value
                    if (!new RegExp('^[0-9]*$').test(value)) {
                      e.target.value = value.substring(0, value.length - 1)
                    }
                    handleInput(e.target.value, 'number_of_children')
                  } }
                />
              </InputCol>
            </FormGroup>
            <TextSection>Emergency Contact</TextSection>
            <FormGroup>
              <LabelCol>
                <Label>Name</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='emergency_contact_name'
                  placeholder='Enter Name'
                  disabled={ !editPersonal }
                  value={ emp.emergency_contact_name || '' }
                  onChange={ e => handleInput(e.target.value, 'emergency_contact_name') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Relationship</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='emergency_relationship'
                  placeholder='Enter Relationship'
                  disabled={ !editPersonal }
                  value={ emp.emergency_relationship || '' }
                  onChange={ e => handleInput(e.target.value, 'emergency_relationship') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Phone Number</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='emergency_phone_number'
                  placeholder='Enter Phone Number'
                  disabled={ !editPersonal }
                  value={ emp.emergency_phone_number || '' }
                  onChange={ e => {
                    const value = e.target.value
                    if (!new RegExp('^[0-9]*$').test(value)) {
                      e.target.value = value.substring(0, value.length - 1)
                    }
                    handleInput(e.target.value, 'emergency_phone_number')
                  } }
                />
              </InputCol>
            </FormGroup>
            <TextSection>System Info.</TextSection>
            <FormGroup>
              <LabelCol>
                <Label>Status User ID</Label>
              </LabelCol>
              <InputCol>
                <SearchSelect
                  name='is_active'
                  placeholder='Select Status User ID'
                  value={ status }
                  isDisabled={ !editPersonal }
                  options={ _status }
                  onChange={ e => handleInput(e, 'is_active') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Modified Date</Label>
              </LabelCol>
              <InputCol>
                { moment(emp.updated).format('DD/MM/YYYY') }
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Modified By</Label>
              </LabelCol>
              <InputCol>
                { updated_by ? `${updated_by.first_name} ${updated_by.last_name}` : '-' }
              </InputCol>
            </FormGroup>
          </FormWrapper>
        </Form>
      </Container>
      <Footer>
        { editPersonal ?
          <ButtonGroup>
            <Button
              theme='#28a745'
              icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
              width='70px'
              height='26px'
              disabled={ Object.keys(invalid).length > 0 }
              onClick={ handleClickSavePersonal }
            >
              Save
            </Button>
            <Button
              theme='#6c757d'
              width='70px'
              height='26px'
              onClick={ () => handleClickCancel(emp._id) }
            >
              Cancel
            </Button>
          </ButtonGroup>
          :
          <Button
            theme='#28a745'
            icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
            width='70px'
            height='26px'
            onClick={ () => handleClickEdit(0) }
          >
          Edit
          </Button>
        }
      </Footer>
    </Root>
  )
})

const Root = styled.div`
    display: flex;
    flex-direction: column;
`

const Container = styled.div`
    padding: 16px 24px;
    background: #FFFFFF;
    max-height: calc(100vh - 223px);
    overflow-y: scroll;
`

const Footer = styled.div`
    height: 42px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #F9F9F9;
    padding: 0 24px;
`

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;

    ${p => p.required && `
      ::after {
        content: '*';
        color: red;
      }
    `}
`

const Form = styled.div`
    display: flex;
`

const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    :nth-child(1) {
        padding-right: 6px;
    }

    :nth-last-child(1) {
        padding-left: 6px;
    }
`

const FormGroup = styled.div`
    display: flex;
    margin-bottom: 16px;
`

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;

    div:nth-child(1) {
      margin-right: 12px;
    }
`

const ProfileWrapper = styled.div`
    display: flex;
`

const ProfileText = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12px;

  span:nth-child(1) {
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
  }
`

const UserProfileImage = styled.img`
  width: 48px;
  height: 48px;
  background: #F5F5F5;
  border: 1px solid #EAEAEA;
  border-radius: 50%;
  cursor: pointer;
`

const UploadArea = styled.div`
    width: 130px;
    height: 100%;
    position: relative;
    overflow: hidden;
    cursor: pointer;
`

const UploadText = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: 10px;
    text-decoration-line: underline;
    z-index: 0;
    color: #2D9CDB;
`

const InputFile = styled.input`
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    padding-left: 130px;
    margin-right: -130px;
    z-index: 1;
`

const LabelCol = styled.div`
    display: flex;
    flex: 1;
`

const InputCol = styled.div`
    display: flex;
    flex: 2;

    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const TextSection = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
  margin-bottom: 24px;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/edit-pane/personal-info.js